import { createAction } from "@reduxjs/toolkit";

/**
 * AD-608. Конец сессии пользователя в вкладке: корневой редьюсер (`store/index.ts`)
 * возвращает срезы с данными пользователя к начальному состоянию. Шлёт
 * `SessionCacheReset` — при выходе и при смене пользователя.
 */
export const sessionReset = createAction("session/reset");
